import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { GestockService } from '../services/gestock.service';
import { formatDate } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-banque',
  templateUrl: './banque.component.html',
  styleUrls: ['./banque.component.css']
})
export class BanqueComponent implements OnInit {

  samacaabiyoonwii: any;
  profil: string = '';
  isReadOnly: boolean = false;
  boutiques: any[] = [];
  selectedBoutique: any = null;
  comptes: any[] = [];
  versements: any[] = [];
  retraits: any[] = [];
  transactions: any[] = [];
  datedeb: Date;
  datefin: Date;
  
  nouveauCompte = { nom_banque: '', numero_compte: '' };
  typeTransaction: string = 'versement';
  nouvelleTransaction = { id_compte_banque: '', montant: 0, reference_recu: '' };

  @ViewChild('editCompteDialog') editCompteDialog: TemplateRef<any>;
  editCompteDialogRef: MatDialogRef<any>;
  compteAEditer: any = { id: null, nom_banque: '', numero_compte: '' };

  constructor(private gestockService: GestockService, public dialog: MatDialog) {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    this.profil = sessionStorage.getItem("profil") || '';
    this.isReadOnly = this.profil === 'ADMINISTRATEUR' || this.profil === 'Contrôleur de Gestion';
    this.datedeb = new Date(new Date().setDate(new Date().getDate() - 30));
    this.datefin = new Date();
  }

  ngOnInit(): void {
    if (this.isReadOnly) {
      this.gestockService.getAllPoints(this.samacaabiyoonwii).then(res => {
        if(res.statutreq == 1) {
          this.boutiques = res.data;
          if (this.boutiques && this.boutiques.length > 0) {
            this.selectedBoutique = this.boutiques[0].idPoint;
            this.loadData();
          }
        }
      });
    } else {
      this.loadData();
    }
  }

  loadData() {
    const start = formatDate(this.datedeb, 'yyyy-MM-dd', 'en-US');
    const end = formatDate(this.datefin, 'yyyy-MM-dd', 'en-US');
    const payload = {
      date_debut: start,
      date_fin: end,
      ...(this.selectedBoutique ? { idboutique: this.selectedBoutique } : {})
    };

    this.gestockService.banqueApi(this.samacaabiyoonwii, 'get_comptes', this.selectedBoutique ? { idboutique: this.selectedBoutique } : {}).then(res => {
      if(res.statutreq == 1) this.comptes = res.data;
    });

    const p1 = this.gestockService.banqueApi(this.samacaabiyoonwii, 'get_versements', payload).then(res => {
      if(res.statutreq == 1) this.versements = res.data;
    });

    const p2 = this.gestockService.banqueApi(this.samacaabiyoonwii, 'get_retraits', payload).then(res => {
      if(res.statutreq == 1) this.retraits = res.data;
    });

    Promise.all([p1, p2]).then(() => {
      this.combineTransactions();
    });
  }

  onBoutiqueChange() {
    this.loadData();
  }

  combineTransactions() {
    const listV = (this.versements || []).map(v => ({
      ...v,
      type: 'versement',
      date: v.date_versement
    }));
    const listR = (this.retraits || []).map(r => ({
      ...r,
      type: 'retrait',
      date: r.date_retrait
    }));
    this.transactions = [...listV, ...listR].sort((a, b) => {
      return new Date(b.date).getTime() - new Date(a.date).getTime();
    });
    this.currentPage = 1;
  }

  selectedCompteFilter: any = null;

  get filteredTransactions() {
    if (!this.selectedCompteFilter) {
      return this.transactions;
    }
    return this.transactions.filter(t => t.id_compte_banque == this.selectedCompteFilter);
  }

  get selectedCompteSolde(): number {
    if (!this.selectedCompteFilter) {
      return (this.comptes || []).reduce((sum, c) => sum + (Number(c.solde) || 0), 0);
    }
    const found = (this.comptes || []).find(c => c.id == this.selectedCompteFilter);
    return found ? (Number(found.solde) || 0) : 0;
  }

  get selectedCompteLabel(): string {
    if (!this.selectedCompteFilter) {
      return 'Toutes les banques (Solde Total)';
    }
    const found = (this.comptes || []).find(c => c.id == this.selectedCompteFilter);
    return found ? `${found.nom_banque} (${found.numero_compte})` : '';
  }

  currentPage: number = 1;
  pageSize: number = 10;

  get paginatedTransactions() {
    const list = this.filteredTransactions;
    const start = (this.currentPage - 1) * this.pageSize;
    return list.slice(start, start + this.pageSize);
  }

  totalPages(): number {
    return Math.ceil(this.filteredTransactions.length / this.pageSize) || 1;
  }

  getPages(): number[] {
    const total = this.totalPages();
    const current = this.currentPage;
    const pages: number[] = [];
    let start = Math.max(1, current - 2);
    let end = Math.min(total, start + 4);
    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  getRangeLabel(): string {
    const list = this.filteredTransactions;
    if (list.length === 0) {
      return '0 sur 0';
    }
    const start = (this.currentPage - 1) * this.pageSize + 1;
    const end = Math.min(start + this.pageSize - 1, list.length);
    return `${start} - ${end} sur ${list.length}`;
  }

  ajouterCompte() {
    if(this.isReadOnly) return;
    if(!this.nouveauCompte.nom_banque || !this.nouveauCompte.numero_compte) return;
    this.gestockService.banqueApi(this.samacaabiyoonwii, 'add_compte', this.nouveauCompte).then(res => {
      if(res.statutreq == 1) {
        this.nouveauCompte = { nom_banque: '', numero_compte: '' };
        this.loadData();
      }
    });
  }

  ouvrirEditionCompte(compte: any) {
    if (this.isReadOnly) return;
    this.compteAEditer = { ...compte };
    this.editCompteDialogRef = this.dialog.open(this.editCompteDialog, { width: '400px' });
  }

  sauvegarderCompte() {
    if (this.isReadOnly) return;
    if (!this.compteAEditer.nom_banque || !this.compteAEditer.numero_compte) return;

    this.gestockService.updateCompteBancaire(this.samacaabiyoonwii, this.compteAEditer).then(res => {
      if (res.statutreq == 1) {
        if (this.editCompteDialogRef) this.editCompteDialogRef.close();
        this.loadData();
      } else {
        alert("Erreur: " + res.message);
      }
    });
  }

  enregistrerTransaction() {
    if(this.isReadOnly) return;
    if(!this.nouvelleTransaction.id_compte_banque || this.nouvelleTransaction.montant <= 0) return;
    
    const action = this.typeTransaction === 'versement' ? 'add_versement' : 'add_retrait';
    const label = this.typeTransaction === 'versement' ? 'Versement' : 'Retrait';
    
    this.gestockService.banqueApi(this.samacaabiyoonwii, action, this.nouvelleTransaction).then(res => {
      if(res.statutreq == 1) {
        alert(`${label} enregistré !`);
        this.nouvelleTransaction = { id_compte_banque: '', montant: 0, reference_recu: '' };
        this.loadData();
      } else {
        alert("Erreur: " + res.message);
      }
    });
  }
}
